const getIconAsSvgString = (width, height, theme)=>`<svg width="${width}" height="${height}" viewBox="0 0 40 47" fill="none" xmlns="http://www.w3.org/2000/svg">
  <ellipse opacity="0.4" cx="20" cy="40.5" rx="5.36842" ry="1" fill="black"/>
  <g filter="url(#shadow)">
    <path d="M21.4203 38.4563C23.0172 36.7144 26.0138 33.1289 28.6184 29.1361C29.921 27.1391 31.1387 25.0205 32.0337 22.9652C32.9226 20.924 33.5263 18.871 33.5263 17.0263C33.5263 9.30363 27.4578 3.5 20 3.5C12.5422 3.5 6.47369 9.30363 6.47369 17.0263C6.47369 18.871 7.07747 20.924 7.96632 22.9652C8.86131 25.0205 10.079 27.1391 11.3817 29.1361C13.9863 33.1289 16.9828 36.7144 18.5797 38.4563C19.3493 39.2957 20.6507 39.2958 21.4203 38.4563Z" fill="${theme.background}" stroke="${theme.foreground}" stroke-width="2"/>
  </g>
  <circle cx="20" cy="17.8684" r="5.36842" fill="${theme.foreground}"/>
  <defs>
  <filter id="shadow" x="1.47369" y="0.5" width="37.0526" height="45.5859" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
  <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset dy="2"/>
  <feGaussianBlur stdDeviation="2"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_19113_15831"/>
  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  <feOffset/>
  <feGaussianBlur stdDeviation="1"/>
  <feComposite in2="hardAlpha" operator="out"/>
  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
  <feBlend mode="normal" in2="effect1_dropShadow_19113_15831" result="effect2_dropShadow_19113_15831"/>
  <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_19113_15831" result="shape"/>
  </filter>
  </defs>
</svg>`
;

export { getIconAsSvgString };
//# sourceMappingURL=icon.js.map
